import CarSelectionContent from './CarSelectionContent';

const CarSelection = () => <CarSelectionContent />;

export default CarSelection;
